import React from 'react';
import { Box, SpaceBetween } from '@amzn/awsui-components-console';
import './WelcomeSection.scss';

const WelcomeSection: React.FC = () => {
    return (
        <Box 
            padding={{ horizontal: 'xxxl', vertical: 'xl' }}
            className="addapt-welcome-section"
        >
            <SpaceBetween size="m" direction="vertical">
                <Box fontSize="heading-xl" fontWeight="bold" color="inherit">
                    ADDAPT
                </Box>
                <Box fontSize="heading-l" color="inherit">
                    Welcome to ADDAPT!
                </Box>
                <Box fontSize="body-m" color="inherit">
                    Your AI-driven solution for efficient data pipeline transformation.
                </Box>
            </SpaceBetween>
        </Box>
    );
};

export default WelcomeSection;